// Client V1 imports
const analytics = require('client/lib/analytics')
// Common V2 imports
const { render } = require('client-v2/common/client')
// Entry imports
const configureStore = require('client-v2/logged-out-landing/state/store')
const rootFactory = require('client-v2/logged-out-landing/components/root').factory
const suSubmitModalActions = require('client-v2/logged-out-landing/containers/su-submit-modal/actions')

render(configureStore, rootFactory)

analytics.setPageContext({
  pageName: 'stream.profile'
})
analytics.track('pageview')

app.store.dispatch(suSubmitModalActions.maybeOpen())
